import ReleaseModalContainer from './ReleaseModal.container';

export default ReleaseModalContainer;



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Trades/TradeDetails/ReleaseModal/index.js